import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import { Grid, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import OmniAssessmentValueTextFab from "../ui/omniAssessmentValueTextFab";
import OmniTextField from "../ui/omniTextField";

const getAnswerTextAsHTML = text => {
  return { __html: `${text}` };
};

const QuestionBloodPressueDisplay = props => {
  const { question, onAnswerSelected, startNextTimer } = props;

  const theme = useTheme();

  const smallScreen = useMediaQuery(theme => theme.breakpoints.down("sm"));

  const defaultDelay = 350;

  const [validAnswerSelected, setValidAnswerSelected] = useState(question.answerValue != null);

  const [sysBpAnswer, setSysBpAnswer] = useState("");

  const [diaBpAnswer, setDiaBpAnswer] = useState("");

  const [unsure, setUnsure] = useState(false);
  const [sysBpError, setSysBpError] = useState(false);
  const [diaBpError, setDiaBpError] = useState(false);

  useEffect(() => {
    if (question.answerValue && question.answerValue[0] === "unsure") {
      setUnsure(true);
    } else if (question.answerValue && question.answerValue[0]) {
      let splits = question.answerValue[0].split("/");
      if (splits.length === 2) {
        setSysBpAnswer(splits[0]);
        setDiaBpAnswer(splits[1]);
      }
    }
  }, [question]);

  useEffect(() => {
    setSysBpError(sysBpAnswer.length === 0 || sysBpAnswer < 40 || sysBpAnswer > 370 ? true : false);
    setDiaBpError(
      diaBpAnswer.length === 0 || diaBpAnswer === 0 || diaBpAnswer > 360 ? true : false,
    );

    if (
      sysBpAnswer.length === 0 ||
      sysBpAnswer < 40 ||
      sysBpAnswer > 370 ||
      diaBpAnswer.length === 0 ||
      diaBpAnswer === 0 ||
      diaBpAnswer > 360
    ) {
      onAnswerSelected(null);
      setValidAnswerSelected(false);
    } else {
      setUnsure(false);
      onAnswerSelected([`${sysBpAnswer}/${diaBpAnswer}`]);
      setValidAnswerSelected(true);
    }
  }, [diaBpAnswer, sysBpAnswer, onAnswerSelected, setUnsure, setDiaBpError, setSysBpError]);

  return (
    <Grid container item direction="row" spacing={4} justifyContent="center">
      <Grid item xs={12} sm={4}>
        <OmniTextField
          key={`answerOptionQuestion${question.omniID}S`}
          name={uuid()}
          value={sysBpAnswer}
          type="number"
          showNumberControls={false}
          onFocus={event => event.target.select()}
          label={"SBP (larger number)"}
          error={sysBpError}
          onChange={event => {
            let onlyNums = event.target.value.toString();
            onlyNums = onlyNums.replace(/[^0-9]/g, "");
            onlyNums = onlyNums.slice(0, 3);
            setSysBpAnswer(onlyNums);
          }}
          sx={{ textAlign: "center" }}
          onKeyPress={e => {
            if (e.key === "Enter" && validAnswerSelected) {
              startNextTimer(defaultDelay);
            }
          }}
          autoFocus
        />
      </Grid>
      <Grid item alignSelf="center" sx={[smallScreen && { display: "none" }]}>
        /
      </Grid>
      <Grid item xs={12} sm={4}>
        <OmniTextField
          key={`answerOptionQuestion${question.omniID}D`}
          name={uuid()}
          value={diaBpAnswer}
          type="number"
          showNumberControls={false}
          onFocus={event => event.target.select()}
          label={"DBP (smaller number)"}
          error={diaBpError}
          onChange={event => {
            let onlyNums = event.target.value.toString();
            onlyNums = onlyNums.replace(/[^0-9]/g, "");
            onlyNums = onlyNums.slice(0, 3);
            setDiaBpAnswer(onlyNums);
          }}
          onKeyPress={e => {
            if (e.key === "Enter" && validAnswerSelected) {
              startNextTimer(defaultDelay);
            }
          }}
        />
      </Grid>
      <Grid item xs={11}>
        <Grid
          id={`questionGrid1`}
          container
          item
          xs={11}
          justifyContent="center"
          spacing={2}
          sx={{ marginLeft: "4px" }}
        >
          <Tooltip title={question.answerOptions[0].helpText || ""} placement="left">
            <Fragment>
              <OmniAssessmentValueTextFab
                key={`answerOption${uuid()}`}
                color="primary"
                size="large"
                variant={"outlined"}
                onClick={e => {
                  setUnsure(true);
                  onAnswerSelected(["unsure"]);
                  startNextTimer(defaultDelay);
                }}
                sx={{ width: "100%", "&:hover": { color: theme.palette.primary.contrastText } }}
              >
                <Grid
                  container
                  justifyContent="center"
                  direction="row"
                  sx={{ width: "100%", alignItems: "center" }}
                >
                  <Grid item justifySelf="center" xs>
                    <Typography
                      variant="button"
                      dangerouslySetInnerHTML={getAnswerTextAsHTML("I don't know")}
                    />
                  </Grid>
                  {unsure && (
                    <CheckCircleRoundedIcon
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 16,
                        maxWidth: "32px",
                        maxHeight: "32px",
                        alignSelf: "baseline",
                      }}
                    />
                  )}
                </Grid>
              </OmniAssessmentValueTextFab>
            </Fragment>
          </Tooltip>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default QuestionBloodPressueDisplay;
